import styled, { css } from "styled-components";

import Button from "@material-ui/core/Button";

export const StyledButton = styled(Button)`
  ${(props) =>
    props.startIcon &&
    css`
      .MuiButton-label {
        .MuiButton-startIcon {
          margin-right: 10px;
        }
      }
    `}

  ${(props) =>
    props.$displayNone &&
    css`
      display: none !important;
    `}

  ${(props) =>
    props.height &&
    css`
      height: ${props.height}!important;
    `}
  background-color: ${(props) => props.theme.palette[props.bgcolor]} !important;
  color: ${(props) => props.theme.palette[props.textcolor]} !important;
  span {
    font-size: 0.925em;
  }
  &:hover {
    background-color: ${(props) =>
      props.theme.palette[props.hovercolor]} !important;
  }
  ${(props) =>
    props.full === "true" &&
    css`
      width: 100% !important;
      height: 100% !important;
    `}
  ${(props) =>
    props.disabled &&
    css`
      background-color: ${(props) => props.theme.palette.darkgrey} !important;
    `}

    ${(props) =>
    props.$sameWidth &&
    css`
      width: 35px !important;

      @media screen and (max-width: 1024px) {
        width: 100% !important;
      }
    `}

    ${(props) =>
    props.fontSize &&
    css`
      font-size: ${props.fontSize} !important;
    `}
`;
